import { render, staticRenderFns } from "./AttachmentsList.vue?vue&type=template&id=3003ca46&"
import script from "./AttachmentsList.vue?vue&type=script&lang=js&"
export * from "./AttachmentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports